
export const OPTION_SIZE = 'Size';
export const ATTRIBUTE_DECORATION_TYPE = 'Decoration type';
export const ATTRIBUTE_DECORATION_LOCATION = 'Select decoration location';
export const ATTRIBUTE_ARTWORK = 'Upload your logo (2MB max)';
export const ATTRIBUTE_LOGO_MOCKUP = 'Logo Mockup Image';
export const ATTRIBUTE_PAYER_TYPE = 'payer_type';
export const ATTRIBUTE_ORDER_TYPE = 'order_type';
export const ATTRIBUTE_SHIP_TO_OFFICE = 'ship_to_office';


export interface IShopifyProductVariant {
  id: string;
  storefrontId: string;
  selectedOptions: Array<{ name: string, value: string }>;
}

export interface IShopifyLineItem {
  quantity: number;
  variant: IShopifyProductVariant | null;
  customAttributes: Array<{ key: string, value: string }>;
}


export function createVariantOptionsMap(productVariant: IShopifyProductVariant) {
  const options = new Map<string, string>();

  productVariant.selectedOptions.forEach(attr => {
    options.set(attr.name, attr.value);
  });

  return options;
}

export function createLineItemAttributesMap(lineItem: IShopifyLineItem) {
  const attributes = new Map<string, string>();

  lineItem.customAttributes.forEach(attr => {
    attributes.set(attr.key, attr.value);
  });

  return attributes;
}

export function mapLineItemToOrderItem(lineItem: IShopifyLineItem) {
  if (!lineItem.variant) {
    throw new Error(
      "Variant for line item " + JSON.stringify(lineItem) + " is missing in MerchStore "
    )
  }

  const attributesMap = createLineItemAttributesMap(lineItem);
  const optionsMap = createVariantOptionsMap(lineItem.variant);

  const orderItem = {
    variantId: lineItem.variant.id,
    quantity: lineItem.quantity,
    size: optionsMap.get(OPTION_SIZE),
    artwork: attributesMap.get(ATTRIBUTE_ARTWORK),
    logoMockup: attributesMap.get(ATTRIBUTE_LOGO_MOCKUP),
    decorationType: attributesMap.get(ATTRIBUTE_DECORATION_TYPE),
    decorationLocation: attributesMap.get(ATTRIBUTE_DECORATION_LOCATION),
  }

  return orderItem;
}